const state = {
  all: { data: [] },
  exportAllLocations: [],
  selectedLocation: null,
  serverTotal: 0,
};

const getters = {
  locations: (state) => state,
  selectedLocation: (state) => state.selectedLocation,
  serverTotal: (state) => state.serverTotal,
  exportAllLocations: (state) => state.exportAllLocations,
};

const actions = {
  async fetchLocations(
    { commit },
    {
      id,
      policyId = null,
      locationId = null,
      results = 10,
      page = 1,
      sortBy = "name",
      sortDesc = false,
      filter = null,
      type = null,
    }
  ) {
    let requestURL = `/restapi/users/${id}/locations/${type}`;
    if (policyId) requestURL += `?policyid=${policyId}`;
    if (locationId) requestURL += `?location_id=${locationId}`;

    const linkSymbol = policyId || locationId ? "&" : "?";

    const sortDir = sortDesc[0] === false ? "asc" : "desc";
    const offset = results * page - results;
    const sortkey =
      sortBy === "os"
        ? "extra_info"
        : sortBy === "policy_name"
        ? "policy"
        : sortBy;

    if (results) requestURL += `${linkSymbol}limit=${results}`;
    if (page) requestURL += `&offset=${offset}`;
    if (sortBy) requestURL += `&sortkey=${sortkey}`;
    if (sortDir) requestURL += `&sortdir=${sortDir}`;
    if (filter) requestURL += `&filter=${filter}`;
    const response = await this._vm.$http.get(requestURL);

    response.data.data = response.data.data.map((location) => {
      if (location.policy_name === null) {
        location.policy_name = "";
      }
      if (location.type === "staticip" && location.addresses[0] !== undefined) {
        return { ...location, ip: location.addresses[0].ip };
      }
      return location;
    });
    commit("setLocations", {
      type,
      data: response.data,
    });
    commit("setServerTotal", response.data.total);
  },

  async fetchExportLocations({ commit }, { id }) {
    let requestURL = `/restapi/users/${id}/locations/all`;
    const response = await this._vm.$http.get(requestURL);
    commit("setExportAllLocations", response.data.data || []);
  },

  async fetchScrollLocations(
    { commit },
    {
      id,
      policyId = null,
      locationId = null,
      results = 10,
      page = 1,
      sortBy = "name",
      sortDesc = false,
      filter = null,
      type = null,
    }
  ) {
    let requestURL = `/restapi/users/${id}/locations/${type}`;
    if (policyId) requestURL += `?policyid=${policyId}`;
    if (locationId) requestURL += `?location_id=${locationId}`;

    const linkSymbol = policyId || locationId ? "&" : "?";

    const sortDir = sortDesc[0] === false ? "asc" : "desc";
    const offset = results * page - results;
    const sortkey =
      sortBy === "os"
        ? "extra_info"
        : sortBy === "policy_name"
        ? "policy"
        : sortBy;

    if (results) requestURL += `${linkSymbol}limit=${results}`;
    if (page) requestURL += `&offset=${offset}`;
    if (sortBy) requestURL += `&sortkey=${sortkey}`;
    if (sortDir) requestURL += `&sortdir=${sortDir}`;
    if (filter) requestURL += `&filter=${filter}`;
    const response = await this._vm.$http.get(requestURL);

    response.data.data = response.data.data.map((location) => {
      if (location.policy_name === null) {
        location.policy_name = "";
      }
      if (location.type === "staticip" && location.addresses[0] !== undefined) {
        return { ...location, ip: location.addresses[0].ip };
      }
      return location;
    });

    commit("addLocations", {
      type,
      data: response.data.data,
    });
  },

  async fetchLocation({ commit }, { id, type, locationId }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/locations/${type}/${locationId}`
    );

    commit("setSelectedLocation", response.data);
  },

  async createLocation({ commit }, { id, type, body }) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}/locations/${type}`,
      body
    );
    if (response.data.type === "staticip") {
      response.data = { ...response.data, ip: response.data.addresses[0].ip };
    }
    commit("addLocation", response.data);

    return response.data;
  },

  async updateLocation({ commit }, { id, type, locationId, body }) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}/locations/${type}/${locationId}`,
      body
    );

    if (response.data.type === "staticip") {
      response.data = { ...response.data, ip: response.data.addresses[0].ip };
    }

    const index = state.all.data.findIndex(
      (location) => location.id === response.data.id
    );

    commit("updateLocation", { data: response.data, idx: index });
    commit("setSelectedLocation", response.data);
  },

  async deleteLocations({ commit }, { userId, locations }) {
    const req = {};

    for (const location of locations) {
      req[`${location.id}`] = {
        method: "delete",
        path: `users/${userId}/locations/${location.type}/${location.id}`,
      };
    }

    const res = await this._vm.$http.post("/restapi/batch", req);
    const ids = Object.keys(res.data).map((item) => +item);
    commit("deleteLocation", ids);
  },
};

const mutations = {
  setLocations: (state, data) => (state.all = data.data),
  setExportAllLocations: (state, payload) =>
    (state.exportAllLocations = payload),
  setServerTotal: (state, data) => (state.serverTotal = data),
  addLocations(state, data) {
    state.all.data.push(...data.data);
    const uniqueIds = new Set();
    const unique = state.all.data.filter((element) => {
      const isDuplicate = uniqueIds.has(element.id);

      uniqueIds.add(element.id);

      if (!isDuplicate) {
        return true;
      }

      return false;
    });
    state.all.data = unique;
  },
  setSelectedLocation: (state, data) => (state.selectedLocation = data),
  addLocation(state, data) {
    state.all.data.push(data);
    state.serverTotal++;
  },
  updateLocation: (state, data) => (state.all.data[`${data.idx}`] = data.data),
  deleteLocation(state, locations) {
    for (const location of locations) {
      state.all.data = state.all.data.filter(
        (stateLocation) => stateLocation.id !== location
      );
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
